import React from 'react';
import './Features.css';

import { features } from '../../../constants';
import { Feature } from '../../../components';



const Features = () => {

  // Extract top 3 features
  const topFeatures = features.slice(0, 3);

  return (
    <section className='features home-features'>
      <div className="box-container">
        {topFeatures.map((feature) => (
          <Feature key={feature.id} feature={feature} />
        ))}
      </div>
    </section>
  );
}

export default Features;